import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';

import { useLocation } from "@reach/router"
import url from 'url';

import Segment from 'utils/segment'
import config from 'utils/siteConfig';

import Twitter from './Twitter';
import Facebook from './Facebook';

const CharlesMeta = ({
  data, title, description, image, canonicalPathname, segmentCategory, noIndex
}) => {
  const {
    siteUrl,
    canonicalSiteUrl,
    siteName,
    twitter,
    facebook,
  } = config

  const pathname = useLocation().pathname
  const actualCanonicalPathname = canonicalPathname || pathname
  const shareImage = url.resolve(
    siteUrl,
    image || data.image || config.shareImage,
  );

  description = description
        || data.description
        || config.siteDescriptionMeta;
  title = title
        || data.name
        || data.title
        || config.siteTitleMeta;

  const siteLanguage = 'FR';

  const seo = {
    title: title,
    description: description,
    image: shareImage,
    url: `${siteUrl}${pathname || ''}`,
    canonicalUrl: `${canonicalSiteUrl}${actualCanonicalPathname || ''}`,
  }

  if (!seo.title) {
    console.error(`[CATCHED] no SEO title for ${seo.url}`)
  }
  if (!seo.description) {
    console.error(`[CATCHED] no SEO description for ${seo.url}`)
  }

  return (
    <>
      <Helmet defer={false}>
        <html lang={siteLanguage} />
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <link rel="canonical" href={seo.canonicalUrl} />
        <script type="text/javascript" src="//dynamic.criteo.com/js/ld/ld.js?a=118847" async="true"></script>
        <meta name={Segment.PAGE_CATEGORY_META_NAME} content={segmentCategory} />
        {noIndex && <meta name="robots" content="noindex"/>}
      </Helmet>
      <Twitter
        title={seo.title}
        desc={seo.description}
        type={'summary'}
        image={seo.image}
        username={twitter}
        url={seo.url}
      />
      <Facebook
        title={seo.title}
        desc={seo.description}
        type={'website'}
        image={seo.image}
        locale={siteLanguage}
        name={facebook}
        url={seo.url}
      />
    </>
  );
};

CharlesMeta.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
  }),
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  type: PropTypes.oneOf(['WebSite', 'Series']),
  canonicalPathname: PropTypes.string,
  segmentCategory: PropTypes.string,
  noIndex: PropTypes.bool
};
CharlesMeta.defaultProps = {
  data: {},
  noIndex: false
};

export default CharlesMeta;
